import { Object3D } from 'three';

import { NavMesh } from '@spazious/dollhouse-navmesh';

declare module 'three' {
  export interface Object3D {
    navMesh?: NavMesh;
  }
}

if (!Object.hasOwn(Object3D.prototype, 'navMesh')) {
  Object.defineProperty(Object3D.prototype, 'navMesh', {
    get: function navMeshAccessor() {
      return this.userData.navMesh;
    },
    set: function (navMesh: NavMesh | null | undefined) {
      this.userData.navMesh = navMesh;
    },
  });
}
